<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            Subject: Second Request for Verification of Disputed Items on Credit Report
        </p>
        <p>
            Dear {{creditBureau.name}},
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I am writing to reiterate my previous request regarding certain items on my credit report that remain unverified. This letter serves as my second formal request for the removal of these items, as mandated by the Fair Credit Reporting Act (FCRA).
        </p>
        <p class="letter-content">
            Your response to my initial dispute claimed that the items in question were "reported correctly" after verification. However, I have not been furnished with details regarding who verified these items or the methods used for such verification. Pursuant to FCRA 611(a)(7), I am requesting a comprehensive account of the procedures employed during your investigation.
        </p>
        <p class="letter-content">
            I must emphasize that the required original creditor's documentation has not been provided to me, as required by FCRA Sections 609(a)(1)(A) and 611(a)(1)(A). The absence of a consumer contract with my signature is notable. According to FCRA Section 611(5)(A), you are obligated to "promptly DELETE all information which cannot be verified."
        </p>
        <p class="letter-content">
            Please be aware that the FCRA outlines specific civil liabilities and remedies for consumers in the event of "negligent noncompliance" as per Section 617. I am prepared to take legal action to ensure compliance with these regulations.
        </p>
        <p class="letter-content">
            Therefore, I insist on the immediate verification or deletion of the following accounts:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            I trust that you will address this matter with the urgency and seriousness it warrants.
        </p>
        <p>
            Sincerely
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                address,
            };
        },
    };
</script>
